import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter',
  template: `
    <div class="row">
      <div class="col-md-2">
        <h6>Matricule</h6>
        <input class="input__field" type="text" [(ngModel)]="matricule" placeholder="Ex:0000" pInputText />
      </div>
      <div class="col-md-2">
        <h6>Nom ou Prénoms</h6>
        <input class="input__field" type="text" [(ngModel)]="nomPrenoms" placeholder="Nom ou Prénoms" pInputText />
      </div>
      <div class="col-md-2">
        <button class="btn btn-dark mr-2" (click)="filter.emit()" [disabled]="!matricule && !nomPrenoms">Filtrer</button>
        <button class="btn btn-secondary" (click)="clearValue.emit()">Réinitialiser</button>
      </div>
    </div>
  `,
})
export class FilterComponent {
  matricule: string;
  nomPrenoms: string;

  @Output() filter = new EventEmitter<void>();
  @Output() clearValue = new EventEmitter<void>();
}
